/**
 * Custom template
 * This file contains logic specific to a template.
 * It is intended to ONLY be loaded on templates that require
 * this specific functionality.
 **/

import Global from "./lib/global";
import Logger from "./lib/logger";
import KeenSlider from "keen-slider";
import Location from "./lib/location";
import reviewsSlider from "./lib/global-reviews-slider";
import audioMeditations from "./lib/global-audios";
import global5050Slider from "./lib/global-50-50-slider";
import stepsSlider from "./lib/global-steps-slider";
import pressSlider from "./lib/global-press-slider";
import VimeoPlayer from "./lib/vimeo-player-global-block";
import RemoveACStyles from "./lib/remove-ac-styles";

// Vars
// ▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒

const NAME = "Custom";

// Logic
// ▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒

/**
 * init - Initialize the page
 **/
const init = () => {
	Logger.log(`${NAME} > loaded`);
	// Location.checkCountry();
	/* redirect hp */
	const domains = [
		"ca.choosemuse.com",
		"eu.choosemuse.com",
		"intl.choosemuse.com",
	];
	if (domains.includes(location.hostname))
		location.href = "https://choosemuse.com/";
		RemoveACStyles();
		pressSlider();
		reviewsSlider();
		audioMeditations();
		global5050Slider();
		careerSlider();
		stepsSlider();
		collapseable();
		globalResearchCarousel();
		VimeoPlayer();
		ModalCall();
	};

// page-careers.js
const careerSlider = () => {
	function navigation(slider) {
		let wrapper, dots, arrowLeft, arrowRight;
		let isSmallWindow = window.innerWidth < 1024;
		const arrows = {
			large:
				"M 23 49.999 C 23 49.971 23.004 49.945 23.009 49.919 C 23.015 49.887 23.022 49.856 23.035 49.826 C 23.04 49.815 23.039 49.804 23.045 49.793 C 23.052 49.781 23.063 49.774 23.071 49.762 C 23.09 49.733 23.109 49.708 23.135 49.684 C 23.154 49.664 23.173 49.648 23.196 49.634 C 23.21 49.624 23.22 49.61 23.236 49.602 C 30.472 45.872 31.778 41.374 31.791 41.329 C 31.857 41.091 32.106 40.951 32.341 41.015 C 32.579 41.079 32.721 41.322 32.656 41.56 C 32.607 41.745 31.444 45.823 25.166 49.551 L 76.552 49.551 C 76.799 49.551 77 49.752 77 49.999 C 77 50.245 76.799 50.446 76.552 50.446 L 25.165 50.446 C 31.443 54.174 32.607 58.253 32.656 58.437 C 32.721 58.676 32.579 58.92 32.34 58.984 C 32.301 58.994 32.262 58.999 32.224 58.999 C 32.025 58.999 31.845 58.867 31.791 58.667 C 31.778 58.623 30.509 54.144 23.236 50.396 C 23.23 50.393 23.228 50.388 23.222 50.385 C 23.212 50.378 23.204 50.369 23.194 50.362 C 23.141 50.326 23.098 50.279 23.065 50.225 C 23.06 50.216 23.05 50.212 23.045 50.203 C 23.039 50.193 23.04 50.182 23.035 50.171 C 23.022 50.141 23.015 50.111 23.009 50.079 C 23.004 50.052 23 50.026 23 49.999 Z",
			small:
				"M7.376 49.616c0-.216.031-.424.076-.639a3.184 3.184 0 0 1 .184-.671c.039-.092.039-.192.084-.284.063-.116.155-.176.224-.284a3.171 3.171 0 0 1 .976-.971c.108-.071.176-.176.284-.231C47.608 26.692 54.631 2.847 54.708 2.547a3.463 3.463 0 0 1 6.676 1.808c-.255.976-6.276 22-37.655 41.8h126.655a3.463 3.463 0 0 1 0 6.931H23.724c31.376 19.792 37.408 40.816 37.663 41.8a3.447 3.447 0 0 1-3.339 4.355 3.471 3.471 0 0 1-3.347-2.571c-.055-.247-6.776-23.955-45.492-43.971-.047-.024-.071-.063-.1-.076-.1-.063-.163-.147-.255-.208a3.384 3.384 0 0 1-.963-1.024c-.039-.071-.131-.1-.171-.176-.047-.092-.047-.192-.084-.284a3.184 3.184 0 0 1-.184-.671 3.016 3.016 0 0 1-.076-.639Z",
		};

		function markup(remove) {
			wrapperMarkup(remove);
			arrowMarkup(remove);
			dotMarkup(remove);
		}

		function removeElement(elment) {
			elment.parentNode.removeChild(elment);
		}
		function createDiv(className) {
			var div = document.createElement("div");
			var classNames = className.split(" ");
			classNames.forEach((name) => div.classList.add(name));
			return div;
		}

		function arrowMarkup(remove) {
			if (remove) {
				removeElement(arrowLeft);
				removeElement(arrowRight);
				return;
			}
			arrowLeft = createDiv("arrow arrow--left");
			arrowLeft.addEventListener("click", () => slider.prev());
			arrowRight = createDiv("arrow arrow--right");
			arrowRight.addEventListener("click", () => slider.next());

			// console.log(arrows["large"])
			arrowRight.innerHTML += `<svg width="9" height="17" viewBox="0 0 9 17" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M0.799805 0.960938L8.26647 8.4276L0.799805 15.8943" stroke="#656F7F" stroke-linecap="round"/></svg>`;
			arrowLeft.innerHTML += `<svg width="9" height="17" viewBox="0 0 9 17" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M8.2002 0.960938L0.733529 8.4276L8.2002 15.8943" stroke="#656F7F" stroke-linecap="round"/></svg>`;

			wrapper.appendChild(arrowLeft);
			wrapper.appendChild(arrowRight);
		}

		function wrapperMarkup(remove) {
			if (remove) {
				var parent = wrapper.parentNode;
				while (wrapper.firstChild)
					parent.insertBefore(wrapper.firstChild, wrapper);
				removeElement(wrapper);
				return;
			}
			wrapper = createDiv("navigation-wrapper");
			slider.container.parentNode.appendChild(wrapper);
			//   wrapper.appendChild(slider.container);
		}

		function dotMarkup(remove) {
			if (remove) {
				removeElement(dots);
				return;
			}
			dots = createDiv("dots");
			let slidesCount = slider.track.details.slides - 1;
			slider.track.details.slides.forEach((slidesCount, idx) => {
				var dot = createDiv("dot");
				dot.addEventListener("click", () => slider.moveToIdx(idx));
				dots.prepend(dot);
			});
			wrapper.prepend(dots);
		}

		function updateClasses() {
			var slide = slider.track.details.rel;
			slide === 0
				? arrowLeft.classList.add("arrow--disabled")
				: arrowLeft.classList.remove("arrow--disabled");
			slide === slider.track.details.slides.length - 1
				? arrowRight.classList.add("arrow--disabled")
				: arrowRight.classList.remove("arrow--disabled");

			Array.from(dots.children).forEach(function (dot, idx) {
				idx === slide
					? dot.classList.add("dot--active")
					: dot.classList.remove("dot--active");
			});
		}

		slider.on("created", () => {
			markup();
			updateClasses();
		});
		slider.on("optionsChanged", () => {
			// console.log(2);
			markup(true);
			markup();
			updateClasses();
		});
		slider.on("slideChanged", () => {
			updateClasses();
		});
		slider.on("destroyed", () => {
			markup(true);
		});
	}

	if (document.getElementById("career_module")) {
		var homeModule = new KeenSlider(
			"#career_module",
			{
				loop: true,
				slides: {
					perView: 1,
				},
				breakpoints: {
					"(min-width: 768px)": {
						loop: false,
						slides: {
							perView: 3,
						},
					},
				},
			},
			[navigation]
		);
	}
};

// page-muse-research
const collapseable = () => {
	Logger.info(`${NAME} > initFaqModule...`);

	const accordionTitles = document.querySelectorAll(
		".global-accordion-wrapper-item__title"
	);

	accordionTitles.forEach((accordionTitle) => {
		accordionTitle.addEventListener("click", () => {
			if (accordionTitle.classList.contains("is-open")) {
				accordionTitle.classList.remove("is-open");
			} else {
				const accordionTitlesWithIsOpen = document.querySelectorAll(".is-open");
				accordionTitlesWithIsOpen.forEach((accordionTitleWithIsOpen) => {
					accordionTitleWithIsOpen.classList.remove("is-open");
				});
				accordionTitle.classList.add("is-open");
			}
		});
	});
};

const globalResearchCarousel = () => {
	function navigation(slider) {
		let wrapper, arrowLeft, arrowRight;
		let isSmallWindow = window.innerWidth < 1024;
		const arrows = {
			large:
				"M 23 49.999 C 23 49.971 23.004 49.945 23.009 49.919 C 23.015 49.887 23.022 49.856 23.035 49.826 C 23.04 49.815 23.039 49.804 23.045 49.793 C 23.052 49.781 23.063 49.774 23.071 49.762 C 23.09 49.733 23.109 49.708 23.135 49.684 C 23.154 49.664 23.173 49.648 23.196 49.634 C 23.21 49.624 23.22 49.61 23.236 49.602 C 30.472 45.872 31.778 41.374 31.791 41.329 C 31.857 41.091 32.106 40.951 32.341 41.015 C 32.579 41.079 32.721 41.322 32.656 41.56 C 32.607 41.745 31.444 45.823 25.166 49.551 L 76.552 49.551 C 76.799 49.551 77 49.752 77 49.999 C 77 50.245 76.799 50.446 76.552 50.446 L 25.165 50.446 C 31.443 54.174 32.607 58.253 32.656 58.437 C 32.721 58.676 32.579 58.92 32.34 58.984 C 32.301 58.994 32.262 58.999 32.224 58.999 C 32.025 58.999 31.845 58.867 31.791 58.667 C 31.778 58.623 30.509 54.144 23.236 50.396 C 23.23 50.393 23.228 50.388 23.222 50.385 C 23.212 50.378 23.204 50.369 23.194 50.362 C 23.141 50.326 23.098 50.279 23.065 50.225 C 23.06 50.216 23.05 50.212 23.045 50.203 C 23.039 50.193 23.04 50.182 23.035 50.171 C 23.022 50.141 23.015 50.111 23.009 50.079 C 23.004 50.052 23 50.026 23 49.999 Z",
			small:
				"M7.376 49.616c0-.216.031-.424.076-.639a3.184 3.184 0 0 1 .184-.671c.039-.092.039-.192.084-.284.063-.116.155-.176.224-.284a3.171 3.171 0 0 1 .976-.971c.108-.071.176-.176.284-.231C47.608 26.692 54.631 2.847 54.708 2.547a3.463 3.463 0 0 1 6.676 1.808c-.255.976-6.276 22-37.655 41.8h126.655a3.463 3.463 0 0 1 0 6.931H23.724c31.376 19.792 37.408 40.816 37.663 41.8a3.447 3.447 0 0 1-3.339 4.355 3.471 3.471 0 0 1-3.347-2.571c-.055-.247-6.776-23.955-45.492-43.971-.047-.024-.071-.063-.1-.076-.1-.063-.163-.147-.255-.208a3.384 3.384 0 0 1-.963-1.024c-.039-.071-.131-.1-.171-.176-.047-.092-.047-.192-.084-.284a3.184 3.184 0 0 1-.184-.671 3.016 3.016 0 0 1-.076-.639Z",
		};

		function markup(remove) {
			wrapperMarkup(remove);
			arrowMarkup(remove);
		}

		function removeElement(elment) {
			elment.parentNode.removeChild(elment);
		}
		function createDiv(className) {
			var div = document.createElement("div");
			var classNames = className.split(" ");
			classNames.forEach((name) => div.classList.add(name));
			return div;
		}

		function arrowMarkup(remove) {
			if (remove) {
				removeElement(arrowLeft);
				removeElement(arrowRight);
				return;
			}
			arrowLeft = createDiv("arrow arrow--left");
			arrowLeft.addEventListener("click", () => slider.prev());
			arrowRight = createDiv("arrow arrow--right");
			arrowRight.addEventListener("click", () => slider.next());

			// console.log(arrows["large"])
			arrowRight.innerHTML += `<svg width="9" height="17" viewBox="0 0 9 17" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M0.799805 0.960938L8.26647 8.4276L0.799805 15.8943" stroke="#656F7F" stroke-linecap="round"/></svg>`;
			arrowLeft.innerHTML += `<svg width="9" height="17" viewBox="0 0 9 17" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M8.2002 0.960938L0.733529 8.4276L8.2002 15.8943" stroke="#656F7F" stroke-linecap="round"/></svg>`;

			wrapper.appendChild(arrowLeft);
			wrapper.appendChild(arrowRight);
		}

		function wrapperMarkup(remove) {
			if (remove) {
				var parent = wrapper.parentNode;
				while (wrapper.firstChild)
					parent.insertBefore(wrapper.firstChild, wrapper);
				removeElement(wrapper);
				return;
			}
			wrapper = createDiv("navigation-wrapper");
			slider.container.parentNode.appendChild(wrapper);
			//   wrapper.appendChild(slider.container);
		}

		function updateClasses() {
			var slide = slider.track.details.rel;
			slide === 0
				? arrowLeft.classList.add("arrow--disabled")
				: arrowLeft.classList.remove("arrow--disabled");
			slide === slider.track.details.slides.length - 1
				? arrowRight.classList.add("arrow--disabled")
				: arrowRight.classList.remove("arrow--disabled");
		}

		slider.on("created", () => {
			markup();
		});
		slider.on("optionsChanged", () => {
			// console.log(2);
			markup(true);
			markup();
		});
		slider.on("slideChanged", () => {});
		slider.on("destroyed", () => {
			markup(true);
		});
	}

	if (document.getElementById("home_module")) {
		var homeModule = new KeenSlider(
			"#home_module",
			{
				loop: true,
				slides: {
					perView: 3,
					spacing: 15,
				},
				breakpoints: {
					"(min-width: 40px)": {
						slides: { perView: 1, spacing: 15 },
					},
					"(min-width: 768px)": {
						slides: { perView: 3, spacing: 15 },
					},
				},
			},
			[navigation]
		);
	}
};

const ModalCall = () => {
	Logger.info(`${NAME} > initModalModule...`);

	const modal = document.querySelectorAll(".modal");
	const overlay = document.querySelector(".overlay");
	const openModalBtn = document.querySelectorAll(".btn[data-modal]");
	const closeModalBtn = document.querySelectorAll(".btn-close");

	const openModal = function () {
		document.body.dataset.modalMode = true;
		document.documentElement.dataset.modalMode = true;
		let selectedModal = document.querySelector(
			".modal[data-modal=" + this.dataset.modal + "]"
		);
		selectedModal.classList.remove("hidden");
		overlay.classList.remove("hidden");
	};

	openModalBtn.forEach((item) => {
		item.addEventListener("click", openModal);
	});

	const closeModal = function () {
		document.body.dataset.modalMode = false;
		document.documentElement.dataset.modalMode = false;
		overlay.classList.add("hidden");
		modal.forEach((item) => {
			item.classList.add("hidden");
		});
	};

	closeModalBtn.forEach((item) => {
		item.addEventListener("click", closeModal);
	});

	overlay.addEventListener("click", closeModal);

	document.addEventListener("keydown", function (e) {
		if (e.key === "Escape" && !modal.classList.contains("hidden")) {
			modalClose();
		}
	});
};

// Bootstrap global functionality
Global();

// Bootstrap page-specific functionality
init();

// Do not edit below this line...
// ▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒
Logger.log(`${NAME} > loaded`);
